import { useEffect, useState } from "react";
import { Link } from "wouter";
import { openBookingModal } from "@/components/booking-modal";

export default function NotFound() {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => { setTimeout(() => setLoaded(true), 100); }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center relative overflow-hidden">
      {/* Ghost number */}
      <div
        className="absolute inset-0 flex items-center justify-center pointer-events-none select-none"
        aria-hidden="true"
      >
        <span
          className="font-serif font-light text-[40vw] leading-none"
          style={{ color: "hsl(166 100% 32% / 0.04)" }}
        >
          404
        </span>
      </div>

      {/* Grain */}
      <div
        className="fixed inset-0 pointer-events-none opacity-[0.04]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`,
          backgroundRepeat: "repeat",
          backgroundSize: "256px 256px",
        }}
      />

      <div
        className="relative z-10 text-center px-6 max-w-xl"
        style={{
          opacity: loaded ? 1 : 0,
          transform: loaded ? "none" : "translateY(24px)",
          transition: "all 0.9s ease 0.2s",
        }}
      >
        <div className="text-[9px] tracking-[0.4em] text-primary/50 uppercase mb-8">
          Ошибка 404
        </div>

        <h1 className="font-serif text-5xl md:text-7xl font-light text-foreground mb-4 leading-tight">
          Кажется, вы<br />
          <span className="text-accent italic">заблудились</span>
        </h1>

        <p className="text-muted-foreground font-light text-lg leading-relaxed mb-12 max-w-sm mx-auto">
          Этой страницы нет — зато есть панорама Петербурга, авторская кухня
          и столик с видом на закат.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            href="/"
            className="bg-primary/20 border border-primary text-accent px-10 py-4 text-[10px] tracking-[0.3em] uppercase hover:bg-primary hover:text-background transition-colors"
          >
            На главную
          </Link>
          <button
            onClick={openBookingModal}
            className="border border-primary/30 text-muted-foreground px-10 py-4 text-[10px] tracking-[0.3em] uppercase hover:border-primary hover:text-accent transition-colors"
          >
            Забронировать стол
          </button>
        </div>

        <div className="mt-16 pt-8 border-t border-primary/10">
          <p className="text-[9px] tracking-[0.3em] uppercase text-primary/30 mb-5">Популярные страницы</p>
          <div className="flex flex-wrap gap-x-6 gap-y-3 justify-center">
            {[
              { href: "/menu", label: "Меню" },
              { href: "/banket", label: "Банкет" },
              { href: "/afisha", label: "Афиша" },
              { href: "/blog", label: "Журнал" },
              { href: "/contacts", label: "Контакты" },
            ].map((link) => (
              <Link
                key={link.href}
                href={link.href}
                className="text-[10px] tracking-[0.2em] uppercase text-muted-foreground/60 hover:text-accent transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
